 (function () {
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartPage() */

    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return

      let timer
      let lastSig = null

      function cartSig() {
        var ids = []
        var nodes = document.querySelectorAll('#CartDrawer .cart-item [data-quantity-variant-id]')
        for (var i = 0; i < nodes.length; i++) ids.push(nodes[i].getAttribute('data-quantity-variant-id'))
        return ids.sort().join(',')
      }

      function filterInCart() {
        var inCart = {}
        var names = document.querySelectorAll('#CartDrawer .cart-item .cart-item__name')
        for (var i = 0; i < names.length; i++) {
          var h = (names[i].getAttribute('href') || '').split('?')[0]
          if (h) inCart[h] = true
        }
        var ups = document.querySelectorAll('#CartDrawer .cart-drawer-upsell-list-item')
        for (var j = 0; j < ups.length; j++) {
          var a = ups[j].querySelector('a[href]')
          var hh = a ? (a.getAttribute('href') || '').split('?')[0] : null
          if (hh && inCart[hh]) ups[j].remove()
        }
      }

      const observer = new MutationObserver(() => {
        if (timer) clearTimeout(timer)

        timer = setTimeout(() => {
          var injected = !!document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
          var sig = cartSig()
          if (sig === '') return
          if (injected && sig === lastSig) return
          lastSig = sig
          insertSectionCartDrawer()
          filterInCart()
        }, 40)
      })

      observer.observe(element, {
        childList: true,
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer

      const observer = new MutationObserver((mutations) => {
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartPage()
  })();

/* ===== Voltist cart fixes (injected via cart-upsell.js): floating drawer + upsell AJAX add ===== */
(function () {
  var scripts = document.getElementsByTagName('script');
  function findSrc(name) {
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src && scripts[i].src.indexOf(name) > -1) return scripts[i].src;
    }
    return null;
  }

  /* 1) Load product-form.js globally so the cart-drawer upsell add works via AJAX (no redirect to cart) */
  if (!(window.customElements && customElements.get('product-form')) && !findSrc('product-form.js')) {
    var base = findSrc('cart-upsell.js');
    if (base) {
      var s = document.createElement('script');
      s.src = base.replace('cart-upsell.js', 'product-form.js');
      s.defer = true;
      document.head.appendChild(s);
    }
  }

  /* 2) Cart drawer as a floating panel (not full screen) + tidy upsell buttons on mobile */
  if (!document.getElementById('voltist-cart-style')) {
    var css = `
    cart-drawer .drawer__inner{border-radius:18px !important;box-shadow:0 12px 40px rgba(0,0,0,.18) !important;height:calc(100% - 20px) !important;top:10px !important;bottom:10px !important;}
    @media screen and (max-width:749px){cart-drawer .drawer__inner{width:90vw !important;max-width:90vw !important;}}
    #cart-drawer-upsell{padding:1rem 1.5rem !important;}
    .cart-drawer-upsell-title{text-align:right !important;font-weight:800 !important;font-size:16px !important;opacity:1 !important;padding:0 0 6px !important;}
    .cart-drawer-upsell-list,.cart-drawer-upsell-list[data-list-style-cart-drawer='scroll']{display:flex !important;flex-direction:column !important;gap:10px !important;grid-auto-flow:unset !important;grid-auto-columns:unset !important;overflow:visible !important;padding:0 !important;margin:0 !important;}
    .cart-drawer-upsell-list-item,.cart-drawer-upsell-list[data-list-style-cart-drawer='scroll'] .cart-drawer-upsell-list-item{display:flex !important;flex-direction:row !important;align-items:center !important;gap:12px !important;width:100% !important;padding:10px !important;border:1px solid #ececec !important;border-radius:14px !important;box-shadow:none !important;flex-shrink:1 !important;}
    .cart-drawer-upsell-list-item-left{flex:0 0 58px !important;width:58px !important;margin:0 !important;}
    .cart-drawer-upsell-list-item-left img{width:58px !important;height:58px !important;object-fit:contain !important;}
    .cart-drawer-upsell-list-item-right{flex:1 1 auto !important;width:auto !important;display:flex !important;flex-direction:column !important;gap:6px !important;text-align:right !important;}
    .cart-drawer-upsell-list-item .cart-item__name{margin:0 !important;font-size:14px !important;font-weight:800 !important;text-align:right !important;}
    .cart-drawer-upsell-list-item .lumin-wrapper{display:flex !important;flex-direction:row !important;align-items:center !important;justify-content:space-between !important;gap:8px !important;grid-template-columns:none !important;}
    .cart-drawer-upsell-list-item .product-option{font-weight:800 !important;font-size:14px !important;margin:0 !important;}
    .cart-drawer-upsell-list-item .field-wrapper{min-width:0 !important;width:auto !important;flex:1 !important;}
    .cart-drawer-upsell-list-item .select__select{height:34px !important;min-height:34px !important;border-radius:8px !important;font-size:12px !important;text-align:center !important;}
    .cart-drawer-upsell-list-item button[name='add']{background:#ffd400 !important;color:#1a1a1a !important;border:none !important;border-radius:10px !important;box-shadow:0 4px 0 #cc9f00 !important;font-weight:800 !important;font-size:13px !important;height:36px !important;min-height:36px !important;padding:0 18px !important;width:auto !important;white-space:nowrap !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;}
    .cart-drawer .cart-item__image{border-radius:12px !important;border:1px solid #f0f0f0 !important;}
    .cart-drawer .cart-item.voltist-gift{display:none !important;}
    .cart-drawer .cart-item__details[data-vsave]::after{content:attr(data-vsave);display:block;width:-moz-fit-content;width:fit-content;background:#ffd400;color:#1a1a1a;font-weight:800;font-size:11px;line-height:1;border-radius:20px;padding:5px 10px;margin-top:7px;}
    .cart__checkout-button,#CartDrawer-Checkout{background:#ffd400 !important;color:#1a1a1a !important;border:none !important;border-radius:14px !important;box-shadow:0 5px 0 #cc9f00 !important;font-weight:800 !important;}
    .totals__total-value{font-weight:800 !important;}
    .drawer__heading{font-weight:800 !important;}
    `;
    var st = document.createElement('style');
    st.id = 'voltist-cart-style';
    st.textContent = css;
    document.head.appendChild(st);
  }
})();

/* ===== Voltist gift-control fix: keep qty/remove controls on real cart items (only the free 0-price gift stays locked). Fixes the gift script hiding the wrong line by index after AJAX upsell add. ===== */
(function () {
  var giftVars = {};
  function refreshGiftVars() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        giftVars = {};
        (cart.items || []).forEach(function (i) {
          if (i.final_line_price === 0 || i.price === 0) giftVars[i.variant_id] = true;
        });
      })
      .catch(function () {});
  }
  var SELS = '.cart-item__quantity, .cart-item__quantity-wrapper, .cart-drawer-quantity-wrapper, quantity-input, cart-remove-button';
  function apply() {
    var items = document.querySelectorAll('cart-drawer .cart-item, #CartDrawer .cart-item');
    [].forEach.call(items, function (item) {
      var po = item.querySelector('.cart-item__details .product-option');
      var price = num(po && po.textContent);
      var isGift = (price === 0);
      if (isGift) {
        if (!item.classList.contains('voltist-gift')) item.classList.add('voltist-gift');
      } else {
        if (item.classList.contains('voltist-gift')) item.classList.remove('voltist-gift');
        [].forEach.call(item.querySelectorAll(SELS), function (el) {
          if (el.style && el.style.display === 'none') el.style.removeProperty('display');
        });
      }
    });
    var realCount = 0;
    [].forEach.call(document.querySelectorAll('#CartDrawer .cart-item'), function (item) {
      if (item.classList.contains('voltist-gift')) return;
      var qi = item.querySelector('.quantity__input');
      realCount += qi ? (parseInt(qi.value, 10) || 0) : 0;
    });
    var heading = document.querySelector('#CartDrawer .drawer__heading');
    if (heading) {
      var ht = heading.textContent, numStr = '';
      for (var hi = 0; hi < ht.length; hi++) { var hc = ht.charAt(hi); if (hc >= '0' && hc <= '9') numStr += hc; }
      if (numStr && numStr !== String(realCount)) heading.textContent = ht.replace(numStr, String(realCount));
    }
  }
  function num(s) {
    if (!s) return null;
    var str = String(s), d = '', started = false;
    for (var i = 0; i < str.length; i++) {
      var c = str.charAt(i);
      if ((c >= '0' && c <= '9') || c === '.') { d += c; started = true; }
      else if (started) break;
    }
    return d ? parseFloat(d) : null;
  }
  function badges() {
    [].forEach.call(document.querySelectorAll('cart-drawer .cart-item, #CartDrawer .cart-item'), function (item) {
      var det = item.querySelector('.cart-item__details');
      if (!det) return;
      var o = num((item.querySelector('.cart-item__details s') || {}).textContent);
      var n = num((item.querySelector('.cart-item__details .product-option') || {}).textContent);
      var pct = (o && n && o > n) ? Math.round((1 - n / o) * 100) : 0;
      var want = pct > 0 ? ('חיסכון ' + pct + '%') : null;
      if (want) { if (det.getAttribute('data-vsave') !== want) det.setAttribute('data-vsave', want); }
      else if (det.hasAttribute('data-vsave')) det.removeAttribute('data-vsave');
    });
  }
  function run() { apply(); badges(); }
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; Promise.resolve().then(function () { scheduled = false; run(); }); }
  run();
  try {
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        run(); setTimeout(run, 450);
      });
    }
  } catch (e) {}
  (function startMO() {
    var dr = document.querySelector('cart-drawer');
    if (!dr) { setTimeout(startMO, 500); return; }
    new MutationObserver(schedule).observe(dr, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  })();
})();

/* ===== Voltist: on product pages, preselect the 2nd bundle option (bigger quantity) by default. Respects the shopper if they pick another option. ===== */
(function () {
  function pick() {
    var radios = document.querySelectorAll('.tpc-bb-radio');
    if (radios.length < 2) return false;
    if (!radios[0].checked) return true;
    radios[1].click();
    return true;
  }
  function init() {
    if (pick()) return;
    var n = 0;
    var iv = setInterval(function () { n++; if (pick() || n > 25) clearInterval(iv); }, 120);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ===== Voltist: keep the cart drawer in sync. The bundle-builder ADD and the free-gift VEX add/remove change the cart WITHOUT re-rendering the drawer and WITHOUT firing cartUpdate (e.g. the gift book lingers after the diffuser is removed). An app monkey-patches fetch, so continuous polling causes jank. Instead, run a SHORT burst of checks only after a user action (any click inside the drawer or on the bundle form) or when the drawer opens; once the cart is STABLE but the rendered rows don't match, re-render once via the theme's native renderContents. Idle => no checks => no jank. ===== */
(function () {
  var syncing = false, checking = false, lastCount = -1, burstTimer = null, burstN = 0;
  function syncDrawer() {
    if (syncing) return;
    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.renderContents !== 'function' || typeof cd.getSectionsToRender !== 'function') return;
    syncing = true;
    var secs = cd.getSectionsToRender().map(function (s) { return s.section || s.id; });
    fetch('/?sections=' + secs.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cd.renderContents({ sections: data });
        cd.classList.toggle('is-empty', document.querySelectorAll('#CartDrawer .cart-item').length === 0);
      })
      .catch(function () {})
      .then(function () { syncing = false; });
  }
  function pollOnce() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !cd.classList.contains('active') || syncing || checking) return;
    checking = true;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart) {
          var rows = document.querySelectorAll('#CartDrawer .cart-item').length;
          if (cart.item_count === lastCount && rows !== cart.item_count) syncDrawer();
          lastCount = cart.item_count;
        }
      })
      .catch(function () {})
      .then(function () { checking = false; });
  }
  function startBurst() {
    burstN = 0;
    if (burstTimer) return;
    burstTimer = setInterval(function () {
      burstN++;
      pollOnce();
      if (burstN >= 7) { clearInterval(burstTimer); burstTimer = null; }
    }, 750);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && (t.closest('cart-drawer') || t.closest('form.tpc-bbf'))) startBurst();
  }, true);
  (function watch() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) { setTimeout(watch, 500); return; }
    var wasActive = cd.classList.contains('active');
    new MutationObserver(function () {
      var active = cd.classList.contains('active');
      if (active && !wasActive) { lastCount = -1; startBurst(); }
      wasActive = active;
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  })();
})();
